import React, { FC } from 'react'
import styles from './ServicesContent.module.scss'
import Service from '../atoms/Service'
import { ServiceEntity } from '../../ducks/services/types'

interface PropsType {
  services: ServiceEntity[]
}

const ServicesContent: FC<PropsType> = ({services}) => {
  return (
    <div className={ styles.servicesContent }>
      <div className={ styles.services }>
        {
          services.map(service => (
            <div className={ styles.serviceContent } key={ service.product_id }>
              <Service service={service} />
              {
                service.sampleMovieURL && service.sampleMovieURL.size_560_360 &&
                <div className={ styles.sampleUrlContainer}>
                  <a
                    className={ styles.sampleUrl }
                    href={ service.sampleMovieURL.size_560_360 }
                    target="_blank" rel="noopener">無料サンプル動画を見る
                  </a>
                </div>
              }
            </div>
          ))
        }
      </div>
    </div>
  )
}

export default ServicesContent